export const ENTITY_LINK_PREFIX = "#entity:";

type Mark = { type: string; attrs?: { href?: string | null } };
type DocNode = { marks?: Mark[]; content?: DocNode[] } & Record<string, unknown>;

export const withoutUnroutableEntityLinks = (tiptapJson: string, canOpen: (id: string) => boolean): string =>
  JSON.stringify(stripNode(JSON.parse(tiptapJson) as DocNode, canOpen));

export const entityIdFromHref = (href: string | null | undefined): string | null => {
  if (!href) {
    return null;
  }
  const at = href.indexOf(ENTITY_LINK_PREFIX);
  return at === -1 ? null : decodeURIComponent(href.slice(at + ENTITY_LINK_PREFIX.length));
};

const stripNode = (node: DocNode, canOpen: (id: string) => boolean): DocNode => {
  const marks = node.marks?.filter((mark) => keepsMark(mark, canOpen));
  return {
    ...node,
    ...(node.marks ? { marks } : {}),
    ...(node.content ? { content: node.content.map((child) => stripNode(child, canOpen)) } : {}),
  };
};

const keepsMark = (mark: Mark, canOpen: (id: string) => boolean): boolean => {
  if (mark.type !== "link") {
    return true;
  }
  const id = entityIdFromHref(mark.attrs?.href);
  return id === null || canOpen(id);
};
